/**
 * Enables a reduced debounce value for batching Add To Cart actions
 */
export const OPTIMIZE_ADD_TO_CART_BATCHING_DEBOUNCE_VALUE_240919 = 'OPTIMIZE_ADD_TO_CART_BATCHING_DEBOUNCE_VALUE_240919';
